import { useWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { useSetAtom } from "jotai";
import { shortenString } from "../../helper/string";
import { walletPublicKeyAtom } from "../../atoms/wallet";
import { authTokenAtom } from "../../atoms/auth";
import { login } from "../../service/backend";
import { useEffect } from "react";

const WalletButton = () => {
  const { connected, publicKey } = useWallet();
  const setWalletPublicKey = useSetAtom(walletPublicKeyAtom);
  const setAuthToken = useSetAtom(authTokenAtom);

  useEffect(() => {
    if (connected && publicKey) {
      setWalletPublicKey(publicKey.toString());
      login(publicKey.toString())
        .then((response) => {
          localStorage.setItem("auth_token", response.token);
          setAuthToken(response.token);
        })
        .catch(console.error);
    } else {
      setWalletPublicKey(null);
      localStorage.removeItem("auth_token");
      setAuthToken(null);
    }
  }, [connected, publicKey, setWalletPublicKey]);

  return (
    <div className="wallet-button">
      <WalletMultiButton className="flex items-center justify-center gap-2 bg-secondary text-xs font-bold text-primary dark:bg-primary dark:text-secondary px-2 py-1 rounded-full transition-all !important">
        <svg className="w-6 h-6 fill-current" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12 14a3 3 0 0 1 3-3h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4a3 3 0 0 1-3-3Zm3-1a1 1 0 1 0 0 2h4v-2h-4Z" clipRule="evenodd" />
          <path
            fillRule="evenodd"
            d="M12.293 3.293a1 1 0 0 1 1.414 0L16.414 6h-2.828l-1.293-1.293a1 1 0 0 1 0-1.414ZM12.414 6 9.707 3.293a1 1 0 0 0-1.414 0L5.586 6h6.828ZM4.586 7l-.056.055A2 2 0 0 0 3 9v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2h-4a5 5 0 0 1 0-10h4a2 2 0 0 0-1.53-1.945L17.414 7H4.586Z"
            clipRule="evenodd"
          />
        </svg>
        <span className="hidden sm:inline">{connected && publicKey ? shortenString(publicKey.toString()) : "Connect Wallet"}</span>
      </WalletMultiButton>
    </div>
  );
};

export default WalletButton;
